import { Grid, Typography } from '@mui/material';
import styles from '../ServicesMenu/services.module.scss';
import CONSTANTS from '../../config/constants.json';

const YoundAdultContactus = () => {
    return (
        <div className={styles.YoungadultsContactusLayout}>
            <Grid className={styles.cardContainer}>
                <Typography className={styles.header}>
                    Contactus
                </Typography>
                <div>
                    <Typography className={styles.textcontent}>For information, please contact</Typography>
                </div>
                <div>
                    <Typography className={styles.properspace}><img src='/images/ic_sharp-email.svg' className={styles.iconsstyles} />ec_young_adults@{CONSTANTS.DOMAIN_NAME}</Typography>
                </div>
            </Grid>
        </div>
    )
}
export default YoundAdultContactus;
